import { render } from "./CopyWishlistModal.vue?vue&type=template&id=4e409036&scoped=true"
import script from "./CopyWishlistModal.vue?vue&type=script&lang=js"
export * from "./CopyWishlistModal.vue?vue&type=script&lang=js"

import "./CopyWishlistModal.vue?vue&type=style&index=0&id=4e409036&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e409036"]])

export default __exports__